export class SaasWorkloadBackupStats {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "workload",
            "baseName": "workload",
            "type": "SaasWorkload",
            "format": ""
        },
        {
            "name": "entityCount",
            "baseName": "entityCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "addedItems",
            "baseName": "addedItems",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "addedBytes",
            "baseName": "addedBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "notBackedUpItems",
            "baseName": "notBackedUpItems",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "coverage",
            "baseName": "coverage",
            "type": "SaasWorkloadCoverage",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasWorkloadBackupStats.attributeTypeMap;
    }
    constructor() {
    }
}
